export const ShowInMikolow = false;
export const GreyColor = '#6b7b92';